import { home } from './home';
import { manufacturingSelection } from './manufacturingSelection';
import { renewableEnergy } from './renewableEnergy';
import { techAndMeasures } from './techAndMeasures';
import { techAndMeasureTagTooltips } from './tags-tooltips';
import { allRecommendations } from './recommendations';

export const en = {
  home,
  manufacturingSelection,
  renewableEnergy,
  techAndMeasures,
  techAndMeasureTagTooltips,
  allRecommendations
};
